import { DistritoModel } from './distrito.model';

export class BarrioModel {

  id: number;
  nombre: string;
  distrito: DistritoModel;

  constructor() {
    this.nombre = '';
    this.distrito = new DistritoModel();
  }
}
